export const defaultTableConfig = {
  pageSize: 50,
  sorting: 'first_action_timestamp,desc',
};

export const defaultCountriesTableConfig = {
  pageSize: 50,
  sorting: 'last_visit_timestamp,desc',
};

export default defaultTableConfig;



// WEBPACK FOOTER //
// ./src/utils/dataTable.js